import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import {
  CrmEtapasKanbanRequest,
  CrmReordenarEtapasKanbanRequest,
} from '../../requests/vendas/crm-etapas-kanban.request';
import {
  CreateCrmEtapasKanbanResponse,
  DeleteCrmEtapasKanbanResponse,
  GetCrmEtapasKanbanResponse,
  ListarCrmMovimentacoesEtapaResponse,
} from '../../responses/vendas/crm-etapas-kanban.response';
import {
  CrmCamposEtapaRequest,
  CrmMovimentacoesEtapaRequest,
  CrmPermissoesEtapaRequest,
} from '../../requests/vendas/crm-configuracao-etapa-kanban.request';
import { GetCrmConfiguracaoEtapaResponse } from '../../responses/vendas/crm-configuracao-etapa-kanban.response';
import { ReturnStruct } from '../../structs/return.struct';

/** Etapas do kanban de oportunidades — ATS.Hub.API.CRM/EtapasKanban. */
@Injectable({
  providedIn: 'root',
})
export class CrmEtapasKanbanService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCrm + 'EtapasKanban';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(nome: string = '', incluirContadores: boolean = true): Observable<GetCrmEtapasKanbanResponse> {
    let params = new HttpParams();

    if (nome) {
      params = params.set('nome', nome);
    }

    params = params.set('incluirContadores', String(incluirContadores));

    return this.httpClient
      .get<GetCrmEtapasKanbanResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public listarMovimentacoes(): Observable<ListarCrmMovimentacoesEtapaResponse> {
    const url = `${this.apiUrl}/Movimentacoes`;
    return this.httpClient
      .get<ListarCrmMovimentacoesEtapaResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateCrmEtapasKanbanResponse> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}`;
    return this.httpClient
      .get<CreateCrmEtapasKanbanResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: CrmEtapasKanbanRequest): Observable<CreateCrmEtapasKanbanResponse> {
    return this.httpClient
      .post<CreateCrmEtapasKanbanResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: CrmEtapasKanbanRequest): Observable<CreateCrmEtapasKanbanResponse> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}`;
    return this.httpClient
      .put<CreateCrmEtapasKanbanResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Inativa a etapa com vínculo (oferecido pela exclusão); a recusa vem com um impedimento por linha. */
  public inativar(id: number): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/inativar/${id}`;
    return this.httpClient
      .put<ReturnStruct>(url, {}, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Exige a lista completa de etapas da empresa; devolve o fluxo já renumerado. */
  public reordenar(request: CrmReordenarEtapasKanbanRequest): Observable<GetCrmEtapasKanbanResponse> {
    const url = `${this.apiUrl}/reordenar`;
    return this.httpClient
      .put<GetCrmEtapasKanbanResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public delete(id: number): Observable<DeleteCrmEtapasKanbanResponse> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}`;
    return this.httpClient
      .delete<DeleteCrmEtapasKanbanResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  // ---- Sub-configurações da etapa ----
  public getConfiguracao(id: number): Observable<GetCrmConfiguracaoEtapaResponse> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}/configuracao`;
    return this.httpClient
      .get<GetCrmConfiguracaoEtapaResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarCampos(id: number, request: CrmCamposEtapaRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}/campos`;
    return this.httpClient
      .put<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarMovimentacoes(id: number, request: CrmMovimentacoesEtapaRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}/movimentacoes`;
    return this.httpClient
      .put<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarPermissoes(id: number, request: CrmPermissoesEtapaRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idEtapaKanban/${id}/permissoes`;
    return this.httpClient
      .put<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
